import React, { PureComponent } from 'react'
import HigherOrderField from './higher-order-field.component'

class PureSelect extends PureComponent {
	render() {
		const {
			id,
			icon,
			style,
			values,
			options,
			disabled,
			normalize,
			handleBlur,
			placeholder,
			handleChange
		} = this.props

		return (
			<HigherOrderField
				innerRef={this.elementRef}
				error={this.props.errors[id]}
				{...this.props}>
				<select
					ref="select"
					id={id}
					name={id}
					className={icon ? 'with-icon' : ''}
					placeholder={placeholder}
					disabled={disabled}
					onChange={e => {
						if (normalize) {
							e.target.value = e.target.value
								.normalize('NFD')
								.replace(/[\u0300-\u036f]/g, '')

							e.target.value = e.target.value.replace(/[^a-z\s]/gi, '')
						}
						handleChange(e)
					}}
					onBlur={handleBlur}
					style={style}
					value={values[id] || ''}>
					{[
						<option hidden key={-1} value="">
							{placeholder || 'Selecione uma opção'}
						</option>
					].concat(
						options
							? options.map(({ value, label }, i) => (
									<option key={i} value={value}>
										{label}
									</option>
							  ))
							: []
					)}
				</select>
			</HigherOrderField>
		)
	}
}

export default PureSelect
